<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div :class="['tsa-card', cardClass, dark ? 'tsa-dark' : 'tsa-light']">
    <div class="tsa-card-content">
      <h2>{{ title }}</h2>
      <p>{{ text }}</p>
      <p class="tsa-sub-text" v-if="subText">{{ subText }}</p>
      <p>{{ extraText }}</p>
      <slot></slot>
      <a v-if="buttonText" :class="['tsa-btn', buttonClass]">{{ buttonText }} <ArrowIcon  :bgColor="arrowIconColor" /></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShortStay",
  props: {
    title: String,
    text: String,
    subText: String,
    extraText: String,
    buttonText: String,
    dark: Boolean,
    cardClass: String,
    buttonClass: String,
    img: String,
    imgClass: String,
        arrowIconColor: {
    type: String,
    default: "#736151"
  }
  },
  components: {
    ArrowIcon
  },
};
import "@/assets/scss/custom/triplea/components/_short_stay_section.scss";
import ArrowIcon from "../../../../../components/ArrowIcon.vue";
</script>

<style scoped>
/* ajustes específicos para o Card */
</style>
